var Class           = require("Class"),
    Utils           = require("Utils"),
    $               = require("jquery"),
    Events          = require("Events"),
    ol              = require('openlayers'),
    ModalMessage    = require('./Widget/ModalMessage'),
    PKK5Source      = require('./PKK5ArcGISSource'),
    PKK5Source      = require('./PKK5ArcGISHighlightSource'),
    mapboxgl;

var utils = require("Utils");

var changeContext = function(object, context) {
    $.each(object, function(name, value) {
        object[name] = value.bind(context);
    });
};

var sourceAliases = {
    'yandexMap'    : 'yandex#map',
    'yandexSat'    : 'yandex#satellite',
    'yandexHybrid' : 'yandex#hybrid',
    'yandexPublic' : 'yandex#publicMap',
    'googleRoadmap': 'ROADMAP',
    'googleSat'    : 'SATELLITE',
    'googleHybrid' : 'HYBRID',
    'googleTerrain': 'TERRAIN'
};

// TODO: Нужно унаследоваться от LayerCollection
var BaseLayer = Class.extend({

    includes: Events,

    /**
     *
     */
    initialize: function (view, options, container) {
        var that       = this,
            initSource = -1,
            i,
            baseMap;

        that.view                   = view;
        that.sources                = {};
        that.currentSource          = undefined;
        // Объект с контейнерами OMS, которые участвуют в базовых картах, индексированы по id базовой карты.
        that._baseMapContaiers      = {};
        that._baseMapContaiersReady = $.Deferred();
        that._map                   = view.getMap();
        that._yaMap                 = false;
        that._googMap               = false;
        that._container             = container;
        that._lastRes               = that._map.getView().getResolution();
        that._lastZoom              = that._map.getView().getZoom();
        that._googBaseTimeout       = 0;
        that._yandexBaseTimeout     = 0;
        that._mapboxglBaseTimeout   = 0;
        that.yaContainer            = false;
        that.googContainer          = false;
        that.mapboxGlContainer      = false;
        that._currentMBGLStylesUrl  = '';
        that._pixelRatio            = Math.round(utils.getDevicePixelRatio());

        $.each(BaseMapSyncHandlers, function(name, value) {
            changeContext(BaseMapSyncHandlers[name], that);
        });

        if(that.view.webglEnabled){
            try{
                mapboxgl = require('mapbox-gl');
            }catch(e){
                that.view.webglEnabled = false;
            }
        }

        that._webglFailMessage = false;

        that._webglFailMessage      = new ModalMessage({
            message: 'Не удалось отобразить базовую карту в векторном режиме ' +
                     'из-за отсутствия поддержки технологии WebGL',
            classes: ModalMessage.CLASSES.HIDDEN_CLASS
        });

        // that._webglFailMessage.hide();

        that.setOptions(options);

        that.olLayer = new ol.layer.Tile({});

        that._createSources();

        if (that.options['base_maps'] && that.options['base_maps'].length > 0) {
            for (i in that.options['base_maps']) {
                baseMap = that.options['base_maps'][i];
                if (baseMap.selected && (baseMap.type != 'OMS' || baseMap.vector || baseMap.should_be_vector) && baseMap.value != 'cadastre') {
                    that.switchTo(baseMap.id);
                    initSource = baseMap.id;
                    break;
                }
            }
        }
    },

    setup: function () {
        var that = this;
        return that;
    },

    _setBaseMapContainers: function (baseMapContsMap) {
        var that               = this;
        that._baseMapContaiers = baseMapContsMap;
        that._baseMapContaiersReady.resolve(that._baseMapContaiers);
        return that;
    },

    _getBaseMapContainers: function () {
        return this._baseMapContaiersReady;
    },

    /**
     *
     */
    _createSources: function () {
        var that = this,
            url;

        that.options['base_maps'].forEach(function (base, i) {
            if (base.type == 'OMS') {
                if (!base.vector) return;
                that.sources[base.id] = base.container_id + '';
                if (that.mapboxGlContainer) return;
                that.mapboxGlContainer           = document.createElement('div');
                that.mapboxGlContainer.className = 'omjs-map-container omjs-mapboxgl-base';
                that._container.appendChild(that.mapboxGlContainer);
            } else {
                if (base.type == 'PUBLIC_SERVICE') {
                    if (base.value == 'OSM') {
                        that.sources[base.id] = new ol.source.OSM({
                            crossOrigin : "anonymous",
                            attributions: [
                                '&nbsp;', // место под иконку
                                '&copy; ' +
                                    '<a href="http://www.openstreetmap.org/copyright" target="_blank">'
                                    + that.view.Lang.translate('Участники OpenStreetMap')
                                    + '</a>'
                            ]
                        });
                    }
                    if (base.value == 'ORBISMapBaseMap') {
                        var xyzUrl = "https://maps.orbismap.ru/base.png?x={x}&y={-y}&z={z}";
                        var tilePixelRatio = 1;
                        if (that._pixelRatio > 1) {
                            xyzUrl += '&retina=' + that._pixelRatio;
                            tilePixelRatio = that._pixelRatio;
                        }
                        that.sources[base.id] = new ol.source.XYZ({
                            crossOrigin: "anonymous",
                            url        : xyzUrl,
                            tilePixelRatio: tilePixelRatio
                        });
                    }
                    if (~base.value.indexOf('yandex') || ~base.value.indexOf('google')) {
                        that.sources[base.id] = base.value;
                        if (~base.value.indexOf('yandex') && !that.yaContainer) {
                            that.yaContainer           = document.createElement('div');
                            that.yaContainer.className = 'omjs-map-container omjs-yandex-base';
                            that._container.appendChild(that.yaContainer);
                        }
                        if (~base.value.indexOf('google') && !that.googContainer) {
                            that.googContainer           = document.createElement('div');
                            that.googContainer.className = 'omjs-map-container omjs-google-base';
                            that._container.appendChild(that.googContainer);
                        }
                    }

                    if (base.value == 'cadastre') {
                        that.cdr_layer = new ol.layer.Tile({
                            source: new ol.source.PKK5ArcGISSource({
                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/Cadastre/MapServer',
                                crossOrigin: 'anonymous'
                            }),
                            visible: false
                        });

                        that.cdr_highlight_layer = new ol.layer.Tile({
                            source: new ol.source.PKK5ArcGISHighlightSource({
                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/CadastreSelected/MapServer',
                                crossOrigin: 'anonymous'
                            }),
                            opacity: 0.7,
                            visible: false
                        });

                        that.cdr_zouit_highlight_layer = new ol.layer.Tile({
                            source: new ol.source.PKK5ArcGISHighlightSource({
                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/ZONESSelected/MapServer',
                                crossOrigin: 'anonymous'
                            }),
                            opacity: 0.7,
                            visible: false
                        });
                    }
                } else if (base.type === 'XYZ') {
                    var rPixelRatio = /\{pixelratio([&?][^=]*)?=([^}]+)\}/;
                    var res = base.value.match(rPixelRatio);
                    var replacer = '';
                    var xValues;
                    var xVar = '';
                    var xVal;
                    var xyzUrl = base.value;
                    var tilePixelRatio = 1;
                    if (res) {
                        if (res.length === 3) {
                            if (res[1]) {
                                xVar += res[1] + '=';
                            }
                            xValues = res[2].split(',');
                        } else {
                            xValues = res[1].split(',');
                        }

                        if (that._pixelRatio === 1) {
                            xVal = xValues[that._pixelRatio-1];
                        } else {
                            for ( var n = that._pixelRatio -1; n > 0; n--) {
                                xVal = xValues[n];
                                if (xVal && xVal.trim() !== '') {
                                    tilePixelRatio = n + 1;
                                    break;
                                }
                            }
                        }

                        if (xVal && xVal.trim() !== "") {
                            replacer = xVar + xVal;
                        }
                        xyzUrl = xyzUrl.replace(res[0], replacer);
                    }

                    that.sources[base.id] = new ol.source.XYZ({
                        crossOrigin: "anonymous",
                        url        : xyzUrl,
                        tilePixelRatio: tilePixelRatio
                    });
                } else if (base.type == 'WMS') {
                    var wmsJson = JSON.parse(base.value);
                    url         = wmsJson['url'];
                    delete wmsJson['url'];

                    that.sources[base.id] = new ol.source.TileWMS({
                        crossOrigin: "anonymous",
                        url        : url,
                        params     : wmsJson
                    });
                } else if (base.type == 'ARCGIS') {
                    var arcGisJson = JSON.parse(base.value);
                    url            = arcGisJson['url'];
                    delete arcGisJson['url'];

                    that.sources[base.id] = new ol.source.TileArcGISRest({
                        crossOrigin: "anonymous",
                        url        : url,
                        params     : arcGisJson
                    });
                }
            }
        });

        return that;
    },

    /**
     *
     */
    switchTo: function (sourceId) {
        var that    = this,
            changed = false,
            source,
            i;

        for (i in that.options.base_maps) {
            if (that.options.base_maps[i]['id'] == sourceId && that.options.base_maps[i]['should_be_vector']) {
                that.view.getWidgetManager().addWidget(that._webglFailMessage);
                that._webglFailMessage.once('hide', function(){
                    that.view.getWidgetManager().removeWidget(that._webglFailMessage);
                });
                that._webglFailMessage.show();
            }
        }


        if (that.currentSource == sourceId) {
            return;
        }

        source = that.sources[sourceId];

        if (!source) {
            $(that._container).find('.omjs-map-container').removeClass('no-background');
            that.hide();
            that.currentSource = undefined;
            return that;
        } else {
            that.show();
        }

        if (typeof source !== 'string') {
            $(that._container).find('.omjs-map-container').removeClass('no-background');
            that.olLayer.setSource(source);
            changed = true;

            that.olLayer.setVisible(true);

            $(that._container).find('.ol-scale-line').css('bottom', 8);

            that.hideGoogMap();
            that.hideYaMap();
            that.hideMapboxGlMap();

            that._map
                .getInteractions()
                .forEach(function (interaction) {
                    if (
                        (interaction instanceof omjs.ol.interaction.PinchRotate) ||
                        (interaction instanceof omjs.ol.interaction.DragRotate)
                    ) {
                        interaction.setActive(true)
                    }
                });
        } else {
            that._map
                .getInteractions()
                .forEach(function (interaction) {
                    if (
                        (interaction instanceof omjs.ol.interaction.PinchRotate) ||
                        (interaction instanceof omjs.ol.interaction.DragRotate)
                    ) {
                        interaction.setActive(false)
                    }
                });
            that._map.getView().setRotation(0);

            that.olLayer.setVisible(false);
            $(that._container).find('.omjs-map-container').addClass('no-background');
            $(that._container).find('.ol-scale-line').css('bottom', 21);

            if (~source.indexOf('yandex')) {
                that.hideGoogMap();
                that.initYaMap()
                    .done(function () {
                        that.showYaMap(source)
                    });
                changed = true;
            } else if (~source.indexOf('google')) {
                that.hideYaMap();
                that.initGoogMap()
                    .done(function () {
                        that.showGoogMap(source)
                    });
                changed = true;
            } else {
                that.hideGoogMap();
                that.hideYaMap();
                that._getBaseMapContainers()
                    .done(function () {
                        that.initMapboxGlMap(sourceId);
                        that.showMapboxGlMap(sourceId);
                    });

                changed = true;
            }
        }

        if (changed) {
            that.currentSource = sourceId;
            that.fire('layerChanged', {'layerName': that.currentSource});
        }

        return that;
    },

    /**
     *
     */
    show: function () {
        var that = this,
            source;

        source = that.sources[that.currentSource];

        if (typeof source !== 'string') {
            that.olLayer.setVisible(true);
            $(that._container).find('.ol-scale-line').css('bottom', 8);
        } else {
            $(that._container).find('.ol-scale-line').css('bottom', 21);
            if (~source.indexOf('yandex')) {
                that.showYaMap(source)
            } else if (~source.indexOf('google')) {
                that.showGoogMap(source)
            } else {
                that._getBaseMapContainers()
                    .done(function () {
                        that.showMapboxGlMap(source)
                    })
            }
        }

        return that;
    },

    /**
     *
     */
    hide: function () {
        var that = this,
            source;

        source = that.sources[that.currentSource];

        if (typeof source !== 'string') {
            that.olLayer.setVisible(false);
            $(that._container).find('.ol-scale-line').css('bottom', 21);
        } else {
            $(that._container).find('.ol-scale-line').css('bottom', 8);
            that.hideYaMap();
            that.hideGoogMap();
            that.hideMapboxGlMap();
        }

        return that;
    },

    initYaMap: function () {
        var that = this;
        var def  = $.Deferred();
        var ymapsApi;

        // Яндекс карты ещё не инициализированы
        if (window.ymaps === undefined) {
            // Создаём и добавляем скрипт, который подгрузит на яндекс карты
            ymapsApi = document.createElement('script');
            $('head').append(ymapsApi);
            // Как только скрипт загрузится, API яндекс карт будет доступен
            ymapsApi.onload = function () {
                ymapsApi.onload = void(0);
                // API доступен, но нужно дождаться загрузки внутренних ресурсов яндекса
                window.ymaps.ready(function () {
                    // Дождались всего, можно инициализировать саму карту
                    def.resolve()
                })
            };

            ymapsApi.onerror = function () {
                ymapsApi.onerror = void(0);
                def.reject()
            };

            ymapsApi.setAttribute('type', 'text/javascript');
            // Начинаем загрузку скрипта
            ymapsApi.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU';
        } else {
            def.resolve()
        }

        return def
            .then(function () {
                // Если яндекс карта уже была инициализирована - ничего не делаем.
                if (that._yaMap) return true;

                that.yaContainer.style.display = "block";
                // Как только API яндекс карт полностью инициализируется, мы можем инициализировать яндекс карту
                var view                       = that._map.getView();
                var center                     = view.getCenter();
                center                         = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');

                that._yaMap = new ymaps.Map(that.yaContainer, {
                    center  : [center[1], center[0]],
                    zoom    : view.getZoom(),
                    controls: []
                }, {
                    suppressMapOpenBlock: true,
                    avoidFractionalZoom: false
                });
                return true;
            });
    },

    showYaMap: function (layerName) {
        var that      = this;
        var view      = that._map.getView();
        var center    = view.getCenter();
        var layerType = layerName in sourceAliases ? sourceAliases[layerName] : 'yandex#map';
        center        = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');

        that.yaContainer.style.display = "block";

        that._map.un('precompose', BaseMapSyncHandlers.yandex.syncCenter);
        that._map.getView().un('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
        that._map.un('change:size', BaseMapSyncHandlers.yandex.syncSize);

        that._yaMap.container.fitToViewport();
        that._yaMap.setType(layerType);
        that._yaMap.setCenter([center[1], center[0]], view.getZoom());

        $(that.yaContainer)
            .find('ymaps[class$="copyrights-pane"]')
            .appendTo(that._map.getTargetElement());

        $(that._container).find('ymaps[class$="copyrights-pane"]').show();

        that._lastRes = that._map.getView().getResolution();

        that._map.on('precompose', BaseMapSyncHandlers.yandex.syncCenter);
        that._map.getView().on('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
        that._map.on('change:size', BaseMapSyncHandlers.yandex.syncSize);

        return that;
    },

    hideYaMap: function () {
        var that = this;
        that._map.un('precompose', BaseMapSyncHandlers.yandex.syncCenter);
        that._map.getView().un('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
        that._map.un('change:size', BaseMapSyncHandlers.yandex.syncSize);
        if (that.yaContainer) {
            that.yaContainer.style.display = "none";
            $(that._container).find('ymaps[class$="copyrights-pane"]').hide();
        }

        return that;
    },

    initGoogMap: function () {
        var that = this,
            layerType,
            googleApi,
            def  = $.Deferred();

        if (window.google === undefined) {
            googleApi = document.createElement('script');
            $('head').append(googleApi);
            googleApi.onload = function () {
                googleApi.onload = void(0);
                google.load("maps", "3", {
                    callback: function () {
                        def.resolve()
                    },
                    other_params : 'key=' + that.view.options.google_maps_api_key
                });

            };

            googleApi.onerror = function () {
                googleApi.onload = void(0);
                def.reject()
            };

            googleApi.src = 'https://www.google.com/jsapi';
        } else {
            def.resolve();
        }

        return def
            .then(function () {
                if (that._googMap) return true;
                var view     = that._map.getView();
                var center   = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
                var goCenter = new google.maps.LatLng(center[1], center[0]);

                var mapOptions = {
                    zoom                  : view.getZoom(),
                    center                : goCenter,
                    animatedZoom          : false,
                    disableDefaultUI      : true,
                    keyboardShortcuts     : false,
                    draggable             : false,
                    disableDoubleClickZoom: true,
                    scrollwheel           : false,
                    streetViewControl     : false,
                    mapTypeId             : google.maps.MapTypeId[layerType]
                };

                that.googContainer.style.display = "block";

                that._googMap = new google.maps.Map(that.googContainer, mapOptions);

                setTimeout(function () {
                    $(that.googContainer).find('.gm-style > div:eq(1)').addClass('googlecopy').appendTo(that._map.getTargetElement());
                    $(that.googContainer).find('.gm-style > .gm-style-cc').addClass('googlecopy').appendTo(that._map.getTargetElement());
                    $(that.googContainer).find('.gm-style > .gmnoprint').addClass('googlecopy').appendTo(that._map.getTargetElement());
                    $(that._container).find('.ol-scale-line').css('bottom', 21);
                }, 1000);

                view.on('change:resolution', BaseMapSyncHandlers.google.restrictZoom);

                return true;
            });
    },

    showGoogMap: function (layerName) {
        var that      = this;
        var view      = that._map.getView();
        var center    = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
        var goCenter  = new google.maps.LatLng(center[1], center[0]);
        var layerType = layerName in sourceAliases ? sourceAliases[layerName] : 'ROADMAP';

        if (view.getZoom() > 19) {
            return that.hideGoogMap();
        }

        that.googContainer.style.display = "block";

        that._map.un('precompose', BaseMapSyncHandlers.google.syncCenter);
        view.un('change:resolution', BaseMapSyncHandlers.google.syncZoom);
        that._map.un('change:size', BaseMapSyncHandlers.google.syncSize);

        google.maps.event.trigger(that._googMap, 'resize');

        that._googMap.setOptions({
            zoom  : view.getZoom(),
            center: goCenter
        });
        that._googMap.setMapTypeId(google.maps.MapTypeId[layerType]);

        $(that._container).find('.googlecopy').show();

        that._map.on('precompose', BaseMapSyncHandlers.google.syncCenter);
        view.on('change:resolution', BaseMapSyncHandlers.google.syncZoom);

        // При каждм ресайзе OL карты нужно обновлять состояние Google Карт. Иначе получаем рассинхрон.
        that._map.on('change:size', BaseMapSyncHandlers.google.syncSize);

        return that;
    },

    hideGoogMap: function () {
        var that = this;
        var view = that._map.getView();
        that._map.un('precompose', BaseMapSyncHandlers.google.syncCenter);
        view.un('change:resolution', BaseMapSyncHandlers.google.syncZoom);
        that._map.un('change:size', BaseMapSyncHandlers.google.syncSize);
        if (that.googContainer) {
            that.googContainer.style.display = "none";
            $(that._container).find('.googlecopy').hide();
        }

        return that;
    },

    initMapboxGlMap: function (baseMapId) {
        var that     = this;
        var cont_ids = that._baseMapContaiers[baseMapId];
        var view     = that._map.getView();
        var center   = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
        if (that._glMap || !cont_ids || !cont_ids.length) return that;
        that._currentMBGLStylesUrl = that.options['mapboxStyleUrlTemplate'].replace('{layers}', cont_ids.join(','));

        // mapboxgl.accessToken = 'pk.eyJ1IjoiY3J1ZWxzaWxlbmNlIiwiYSI6Imx5MHJ3S00ifQ.sRd76jrMWJxIc_UPG5tPkA';
        mapboxgl.accessToken           = 'dumb';
        that._glMap                    = new mapboxgl.Map({
            container            : that.mapboxGlContainer,
            preserveDrawingBuffer: true,
            style                : that._currentMBGLStylesUrl,
            interactive          : false,
            attributionControl   : false,
            zoom                 : view.getZoom() - 1,
            center               : center,
            trackResize          : false,
            maxBounds            : null
        });
        // Убираем ограничение на pan
        that._glMap.transform.latRange = null;
    },

    showMapboxGlMap: function (baseMapId) {
        var that     = this;
        var cont_ids = that._baseMapContaiers[baseMapId];
        var view     = that._map.getView();
        var center   = view.getCenter();
        var stylesUrl;
        if (!cont_ids || !cont_ids.length) return that;
        center = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');

        that.mapboxGlContainer.style.display = "block";

        stylesUrl = that.options['mapboxStyleUrlTemplate'].replace('{layers}', cont_ids.join(','));

        if (that._currentMBGLStylesUrl != stylesUrl) {
            that._currentMBGLStylesUrl = stylesUrl;
            that._glMap.setStyle(that._currentMBGLStylesUrl);
        }

        that._glMap.resize();

        that._map.un('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
        that._map.un('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
        that._map.getView().un('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);


        if (isNaN(center[0])) {
            center = [0, 0]
        }
        that._glMap.transform.zoom   = view.getZoom() - 1;
        that._glMap.transform.center = mapboxgl.LngLat.convert(center);

        that._glMap._render();

        that._map.on('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
        that._map.on('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
        that._map.getView().on('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);

        BaseMapSyncHandlers.mapboxgl.restrictZoom.call(that);

        return that;
    },

    hideMapboxGlMap: function () {
        var that = this;
        that._map.un('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
        that._map.un('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
        that._map.getView().un('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);
        if (that.mapboxGlContainer) {
            that.mapboxGlContainer.style.display = "none";
        }

        return that;
    },

    highlightCadastreFeature: function(feature_id) {
        var that = this;
        if (that.cdr_layer && that.cdr_layer.getVisible()) {

            var zouid_regex = /^\d+\.\d+\.\d+/;

            if (feature_id !== null) {

                if (zouid_regex.exec(feature_id)) {
                    // Если просят подсветить ЗОУИД, то включаем слой для подсветки ЗОУИД,
                    // отключаем слой для подсветки обычных объектов
                    if (that.cdr_highlight_layer.getVisible()) {
                        that.cdr_highlight_layer.setVisible(false);
                    }
                    if (!that.cdr_zouit_highlight_layer.getVisible()) {
                        that.cdr_zouit_highlight_layer.setVisible(true);
                    }

                    // Выставляем фичу слою для подсветки ЗОУИДов
                    that.cdr_zouit_highlight_layer
                        .getSource()
                        .setSelectedFeature(feature_id);

                    // Сбрасываем подсветку для обычных фич
                    that.cdr_highlight_layer
                        .getSource()
                        .setSelectedFeature(null);

                } else {
                    // Если просят подсветить обычную фичу, то включаем слой для
                    // подсветки фич и отключаем слой для подсветки ЗОУИДов
                    if (!that.cdr_highlight_layer.getVisible()) {
                        that.cdr_highlight_layer.setVisible(true);
                    }
                    if (that.cdr_zouit_highlight_layer.getVisible()) {
                        that.cdr_zouit_highlight_layer.setVisible(false);
                    }

                    // Выставляем фичу слою для подсветки обычных фич
                    that.cdr_highlight_layer
                        .getSource()
                        .setSelectedFeature(feature_id);

                    // Сбарсываем подсветку для ЗОУИДов
                    that.cdr_zouit_highlight_layer
                        .getSource()
                        .setSelectedFeature(null);

                }
            } else {
                that.cdr_highlight_layer.setVisible(false);
                that.cdr_zouit_highlight_layer.setVisible(false);
                that.cdr_highlight_layer.getSource().emptyCache();
            }
        }
    }

});





var BaseMapSyncHandlers = {
    "yandex"  : {
        "syncCenter": function (e) {
            var that     = this;
            var center   = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');

            that._yaMap.setCenter([center[1], center[0]], that._map.getView().getZoom(),{
                checkZoomRange: false
            });
        },

        "syncZoom": function (e) {

        },

        "syncSize": function () {
            var that   = this;
            var center = that._map.getView().getCenter();
            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');

            that._yaMap.container.fitToViewport();
            that._yaMap.setCenter([center[1], center[0]], that._map.getView().getZoom());
        }
    },
    "google"  : {
        "syncCenter": function (e) {
            var that     = this;
            var startRes = that._lastRes;
            var endRes   = that._map.getView().getResolution();

            if (startRes == endRes) {
                var center = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');
                that._googMap.setCenter(new google.maps.LatLng(center[1], center[0]));
            }

            clearTimeout(that._googBaseTimeout);
            that._googBaseTimeout = setTimeout(function () {
                that._lastRes = that._map.getView().getResolution();
            }, 50)
        },

        "syncZoom": function () {
            var that   = this;
            var center = that._map.getView().getCenter();
            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
            that._googMap.setOptions({
                zoom  : that._map.getView().getZoom(),
                center: new google.maps.LatLng(center[1], center[0])
            });
        },

        "syncSize": function () {
            var that   = this;
            var center = that._map.getView().getCenter();
            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');

            google.maps.event.trigger(that._googMap, 'resize');

            that._googMap.setOptions({
                zoom  : that._map.getView().getZoom(),
                center: new google.maps.LatLng(center[1], center[0])
            });
        },

        "restrictZoom": function () {
            var that          = this;
            var currentSource = that.sources[that.currentSource];
            if (typeof currentSource != 'string' || !~currentSource.indexOf('goog')) return;

            var googleIsShown    = that.googContainer.style.display == "block";
            var googleIsHidden   = !googleIsShown;
            var needToHideGoogle = that._map.getView().getZoom() > 19;
            var needToShowGoogle = !needToHideGoogle;

            if (googleIsShown && needToHideGoogle) { // Если гуглокарта отображена и мы перешли за 19 зум
                // Скрываем гуглокарту
                that.hideGoogMap();
            } else if (googleIsHidden && needToShowGoogle) { // Если гуглокарта не отображена и зум у нас меньше 20
                // Отображаем гуглокарту
                that.showGoogMap(currentSource);
            }
        }
    },
    "mapboxgl": {
        "syncPosition": function (e) {
            var zoom;
            var center;
            var that        = this;
            var newZoom;
            var updateStyle = false;
            that._glMap.stop();
            center = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');
            zoom   = Utils.getZoomFromResolution(e.frameState.viewState.resolution);

            if (isNaN(center[0])) {
                center = [0, 0]
            }

            that._glMap._omsLastZoom = that._glMap.transform.zoom;
            newZoom                  = zoom - 1;
            if (Math.round(that._glMap._omsLastZoom) != newZoom) {
                updateStyle = true;
            }

            that._glMap.transform.zoom   = zoom - 1;
            that._glMap.transform.center = mapboxgl.LngLat.convert(center);

            that._glMap._render();
            clearTimeout(that._mapboxglBaseTimeout);
            that._mapboxglBaseTimeout = setTimeout(function () {
                // that._glMap._update()
                that._glMap._update(updateStyle);
                that._glMap.animationLoop.set(300);
                that._glMap._rerender();
            }, 50);

        },
        "syncSize"    : function () {
            var that   = this;
            var view   = that._map.getView();
            var center = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
            that._glMap.resize();

            that._glMap.transform.zoom   = view.getZoom() - 1;
            that._glMap.transform.center = mapboxgl.LngLat.convert(center);

            that._glMap._render();
        },

        "restrictZoom": function () {
            var that = this;
            if (that._map.getView().getZoom() > 21) {
                that._map.getView().setZoom(21);
            }
        }
    }
};


module.exports = BaseLayer;



//////////////////
// WEBPACK FOOTER
// ./src/View/BaseLayer.js
// module id = 21
// module chunks = 0